import { createFileRoute, redirect } from '@tanstack/react-router';
import { homeFor, requireSignIn } from '../auth/gate';

/**
 * The landing route sends a signed-in user home; a signed-out one to sign-in. A person in no company
 * yet with an invitation waiting answers it first, as after a sign-in (`use-sign-in.ts`), instead of
 * being asked to name a company of their own (first-run walk, 2026-10-11).
 */
export const Route = createFileRoute('/')({
  beforeLoad: async ({ context, location }) => {
    const principal = await requireSignIn(context.auth, location.href);
    const home = homeFor(principal);
    if (home.to === '/sign-up' && (await context.auth.invitationsWaiting()))
      throw redirect({ to: '/invitations' });
    throw redirect(home);
  },
});
